import React, { useState } from 'react';

import { Auth0Notification } from '@a0/support-center-components';
import SecureLink from './SecureLink';
import { getFeatureFlagWithDefault } from '../featureFlags';

const localStorageKey = 'dismissedOngoingChangesBanner';

function isBannerDismissed() {
  return localStorage.getItem(localStorageKey) === 'true';
}

export const OngoingChangesBanner = () => {
  const [bannerDismissed, setBannerDismissed] = useState(isBannerDismissed());

  // if dismissed, we don't want anything.
  if (bannerDismissed) {
    return null;
  }

  const salesforceNavigationEnabled = getFeatureFlagWithDefault('support_center_salesforce_navigation', false);

  // hide if the Salesforce navigation is not enabled
  if (!salesforceNavigationEnabled) {
    return null;
  }

  const dismissBanner = () => {
    localStorage.setItem(localStorageKey, 'true');
    setBannerDismissed(true);
  };

  return (
    <div id="ongoing-changes-banner">
      <Auth0Notification type="primary">
        <button type="button" data-dismiss="alert" aria-label="Close" className="close" onClick={dismissBanner}><span aria-hidden="true">×</span></button>
        <strong>Heads-up!</strong> We are enhancing the Auth0 Support Center to make it easier for
        you to find help. During this time you may notice different styles across pages. Learn more{" "}
        <SecureLink href="https://support.auth0.com/center/s/article/Announcing-the-Enhanced-Auth0-Support-Center">
          here
        </SecureLink>
        .
      </Auth0Notification>
    </div>
  );
};
